module.exports = __webpack_public_path__ + "static/img/sdw.a625030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/sdw.png
// module id = AT7m
// module chunks = 0